module.exports = __webpack_public_path__ + "static/media/remove-track.92b1fa68.svg";